import { observer } from "mobx-react";
import React, { useState } from "react";
import { Stack, Modal, Button } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import { MODALS } from "../../helpers/constants";
import SettingsToggle from "../interactiveData/settingsToggle";
import { TextWithInfoAndIcon } from "../dataDisplay/textWithInfoAndIcon";
import { IconSettings, IconClock } from "@tabler/icons-react";
import { ARTICLES } from "../../docs/docsIndex";
import TwoFaSettings from "../interactiveData/twoFaSettings";

const UserSettings = observer(({ cubby }: { cubby: Cubby }) => {
  const [showTwoFaSettings, setShowTwoFaSettings] = useState(false);

  return (
    <Modal
      opened={cubby.currentModal === MODALS.USER_SETTINGS}
      onClose={() => cubby.setModal(null)}
      title={
        <TextWithInfoAndIcon
          text="Settings"
          articleSlug={ARTICLES.SETTINGS.slug}
          icon={<IconSettings size={24} />}
          cubby={cubby}
          textSize="lg"
        />
      }
    >
      <Stack>
        <SettingsToggle
          label={
            cubby.isAdvancedMode ? "Set-your-own-fee mode" : "Fee Safety Mode"
          }
          checked={!cubby.isAdvancedMode}
          onChange={() => cubby.handleAdvancedModeChange()}
          infoLink="https://docs.megalithic.me/taproot-assets/megalith-assets"
        />

        <SettingsToggle
          label={
            cubby.useUsdForFiat
              ? "Fiat shown in U.S. Dollars"
              : "Fiat shown in Euros"
          }
          checked={cubby.useUsdForFiat}
          onChange={(checked) => cubby.handleUseUsdForFiatChange(checked)}
          infoLink="https://docs.megalithic.me/taproot-assets/megalith-assets"
        />

        <SettingsToggle
          label={
            cubby.useSatoshisForBtc
              ? "Bitcoin shown in Satoshis"
              : "Bitcoin shown in BTC"
          }
          checked={cubby.useSatoshisForBtc}
          onChange={(checked) => cubby.handleUseSatoshisForBtcChange(checked)}
          infoLink="https://docs.megalithic.me/taproot-assets/megalith-assets"
        />

        {cubby.isRequiredToUse2Fa && !showTwoFaSettings && (
          <Button
            variant="light"
            onClick={() => setShowTwoFaSettings(true)}
            leftSection={<IconClock size={20} />}
          >
            Change Two Factor Timeout
          </Button>
        )}

        {showTwoFaSettings && <TwoFaSettings cubby={cubby} />}
      </Stack>
    </Modal>
  );
});

export default UserSettings;
